"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @file fetch tenant with json api

var json_api_fetch_1 = require("./json_api_fetch");
/**
 * Fetch a Tenant object by its ID in json api format
 * @param id Tenant Id
 * @returns A Promise that resolves to a JsonAPIResponse<Tenant>.
 *
 */


function fetchTenant(id) {
  return json_api_fetch_1.jsonApiFetch("tenants/" + id);
}

exports.default = fetchTenant;